<template>
  <filter-wrapper @submit="submit">
    <div class="filter__row">
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('autocaller_v2.products.table.name') }}
        </label>
        <div class="filter__item__body">
          <i-input v-model="form.name" :clearable="true" />
        </div>
      </div>
    </div>
  </filter-wrapper>
</template>

<script>
  import FilterWrapper from '@shared/components/filter-base';
  import { mapActions } from 'vuex';
  import debounce from 'lodash-es/debounce';

  export default {
    components: {
      FilterWrapper
    },
    data: () => ({
      form: {
        name: ''
      }
    }),
    watch: {
      'form.name': function () {
        this.debouncer();
      }
    },
    created() {
      this.submit();
    },
    methods: {
      ...mapActions('autocaller_v2/products/table', ['search']),
      submit: function () {
        const { name = '' } = this.form;

        const params = {
          name
        };
        for (let key in params) {
          params[key] === '' ? delete params[key] : params[key];
        }
        this.search(params);
      },

      debouncer: debounce(function () {
        this.submit();
      }, 1000)
    }
  };
</script>
